export const TIME_IN_MS_UNTIL_INACTIVITY_MODAL_IS_SHOWN = 1000 * 60 * 10; // 10 minutes
export const SIMULATOR_STATUS_POLLING_PERIOD = 2000; // 2 seconds
export const TIME_IN_SEC_UNTIL_SESSION_IS_CLOSED_DUE_TO_INACTIVITY = 60 * 5; // 5 minutes
